<template>
  <header :class="stHeaderPageClass" :style="stHeaderPageStyle">
    <modal :open="modalOpen" @close="closeModal" v-if="formlink">
      <iframe :src="`${formlink}?embedded=true`" width="640" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
    </modal>
    <div class="main-headline-head-wrapper" :style="mainHeadlineHeadStyle">
      <div v-if="header.bannerimage || header.bannervideo" class="st-header-hero" :style="stHeaderHeroStyle">
        <div class="st-content-banner" :style="bannerStyle">
          <img v-if="header.bannerimage" :src="getSource(header.bannerimage)" alt="image"/>
          <video v-else-if="header.bannervideo" loop muted autoplay playsinline :src="getSourceOnce(header.bannervideo)" :poster="getPosterSource(header.poster)"></video>
        </div>
      </div>
      <div class="main-headline-head">
        <div class="main-headline">
          <div v-if="isPremium" class="premium-label">FOR SUBSCRIBERS</div>
          <h1 itemprop="headline" v-markdown="header.headline" :style="textStyle"></h1>
        </div>
      </div>
    </div>

    <div class="main-headline-content-wrapper">
      <div :class="mainHeadlineContentClass">
        <div itemprop="description" class="st-deck" :style="textStyle">
          <p v-for="(pitem, i) in header.deck" v-markdown="pitem" :key="i"></p>
        </div>
        <div class="st-byline" :style="textStyle">
          <time itemprop="datePublished" :datetime="header.datetime" :data-timestamp="timestamp"
            v-markdown="header.byline"></time>
        </div>
        <div class="school-image"><img src="~images/school-header.svg"></div>
      </div>
    </div>
  </header>
</template>

<script>
import Modal from './../../artefacts/Project/Modal.vue'

export default {
  props: ['header'],
  components: {Modal},
  computed: {
    modalOpen () {
      return this.$store.state.modalOpen
    },
    formlink () {
      return this.$store.state.formlink
    },
    isPremium () {
      return process.env.IS_PREMIUM
    },
    timestamp () {
      return new Date(this.header.datetime).getTime()
    },
    bannerStyle () {
      const {bannerwidth} = this.header
      return {
        maxWidth: bannerwidth || null
      }
    },
    textStyle () {
      const {textwidth} = this.header
      return {
        maxWidth: textwidth || null
      }
    },
    isTabletWidth () {
      return this.$window.innerWidth < 768
    },
    currentHeaderMode () {
      return this.isTabletWidth ? this.mobileMode : this.desktopMode
    },
    currentManualHeight () {
      return this.isTabletWidth ? this.defaultMobileHeight : this.defaultDesktopHeight
    },
    mainHeadlineHeadStyle () {
      if (!this.currentHeaderMode) return
      var height = 'auto'
      var display = 'block'
      if (this.header.bannerimage || this.header.bannervideo) {
        if (this.currentHeaderMode.indexOf('fullheight') !== -1) {
          display = 'flex'
          height = (this.currentHeaderMode.indexOf('desktop') !== -1 ? (this.initHeight - 50) : this.initHeight) + 'px'
        }
      }
      return {height, display}
    },
    stHeaderHeroStyle () {
      return {
        backgroundColor: this.header.bg,
        height: this.currentManualHeight
      }
    },
    stHeaderPageStyle () {
      const {bannerimage, bannervideo, bg} = this.header
      return {
        backgroundColor: (!bannerimage && !bannervideo) ? bg : '#fff'
      }
    },
    mainHeadlineContentClass () {
      const {bannerimage, bannervideo, bg} = this.header
      return {
        'main-headline-content': true,
        'plain': !bannerimage && !bannervideo && !bg
      }
    },
    stHeaderPageClass () {
      return {
        'st-header-page': true,
        [this.header.class]: this.header.class
      }
    },
    hasDesktopSource () {
      const {hasdesktop} = this.header
      return !hasdesktop || hasdesktop !== 'false'
    }
  },
  data () {
    return {
      // headerMode: ['desktop', 'desktop_fullheight', 'mobile', 'mobile_fullheight'],
      defaultDesktopHeight: '300px',
      defaultMobileHeight: '300px',
      desktopMode: 'desktop',
      mobileMode: 'mobile_fullheight',
      initHeight: this.$window.innerHeight
    }
  },
  methods: {
    closeModal () {
      this.$store.commit('toggleModal', false)
    },
    getSource (value) {
      const {isTabletWidth, hasDesktopSource} = this
      if (!value) return false
      var path = value
      if (value && !isTabletWidth && hasDesktopSource) {
        var [name, ext] = value.split('.')
        path = name + '-desktop.' + ext
      }
      return require(`images/${path}`)
    },
    getPosterSource (value) {
      let path = null
      if (value) {
        const [name, ext] = value.split('.')
        path = name + (!global.isMobile && this.hasDesktopSource ? '-desktop.' : '.') + ext
      }
      return path ? require(`videos/${path}`) : null
    },
    getSourceOnce (value) {
      const [name, ext] = value.split('.')
      const path = name + (!global.isMobile && this.hasDesktopSource ? '-desktop.' : '.') + ext
      return require(`videos/${path}`)
    }
  },
  mounted () {
    const {desktopheight, mobileheight} = this.header

    if (desktopheight) {
      if (desktopheight === 'fullheight') {
        this.desktopMode = 'desktop_fullheight'
      } else {
        this.defaultDesktopHeight = desktopheight
      }
    }

    if (mobileheight) {
      if (mobileheight !== 'fullheight') {
        this.mobileMode = 'mobile'
        this.defaultMobileHeight = mobileheight
      }
    }

    if (document.getElementById('modal-toggle')) {
      this.$nextTick(() => {
        document.getElementById('modal-toggle').addEventListener('click', e => {
          this.$store.commit('toggleModal', true)
        })
      })
    }
  }
}
</script>

<style lang="scss">
.st-content-banner {
  position: relative;
  height: 100%;
  overflow: hidden;

  @include container;

  img,
  video {
    min-height: 100%;
    min-width: 100%;
    position: absolute;
    right: 50%;
    bottom: 50%;
    transform: translate(50%, 50%);
  }
}

.st-header-page {
  .modal-container {
    z-index: 1;

    .modal-content {
      max-width: 700px;
      height: 80%;

      // google form iframe not scrollable on iOS safari fix
      // https://stackoverflow.com/questions/43262156/cant-scroll-iframe-on-mobile-ios-safari
      -webkit-overflow-scrolling: touch!important;

      iframe {
        position: absolute;
        top: 20px;
        left: 0;
        right: 0;
        bottom: 20px;
        padding: 0;
        margin: 0;
        width: 100%;
        height: calc(100% - 40px);
        overflow: auto;
        z-index: 9;
      }
    }
  }
  .school-image img {
    display: block;
    margin: 60px auto -30px;
    max-width: 100%;

    @include breakpoint($d_medium) {
      width: 800px;
    }
  }
  .main-headline-head-wrapper {
    flex-direction: column;

    .st-header-hero {
      width: 100%;
      flex: 1;
    }

    .main-headline-head {
      width: 100%;
      box-sizing: border-box;
      padding: 0 $outerSpacingMobile;

      @include breakpoint($d_medium) {
        padding: 0 $outerSpacing;
      }

      .main-headline {
        max-width: 700px;
        margin: 0 auto;
        padding: 12px 0 35px;

        @include breakpoint($d_medium) {
          // padding: 25px 0 50px;
          padding: 25px 0 42px;
        }

        .premium-label {
          font-family: $font-SelaneForty;
          font-size: 18px;
          line-height: 21.6px;
          white-space: nowrap;
          text-transform: uppercase;
          color: $black;
          display: inline-block;
          border-top: 5px solid #13fdfd;
          margin-bottom: 5px;
        }

        h1 {
          margin: 0;
          text-align: left;
          color: $black;
          font-family: $font-SelaneForty;
          font-size: 32px;
          line-height: 35px;

          @include breakpoint($d_medium) {
            font-family: $font-SelaneTwenty;
            font-size: 50px;
            line-height: 52px;
          }

          span {
            color: $red !important;
          }
        }
      }
    }
  }

  .main-headline-content-wrapper {
    box-sizing: border-box;
    padding: 0 $outerSpacingMobile;

    @include breakpoint($d_medium) {
      padding: 0 $outerSpacing;
    }

    .main-headline-content {
      max-width: 700px;
      margin: 0 auto;

      .st-deck p {
        text-align: left;
        font-family: $font-SelaneTextRegular;
        font-size: 20px;
        line-height: 28px;
        color: #494949;
        padding-bottom: 12px;

        @include breakpoint ($d_medium) {
          font-size: 23px;
          line-height: 30px;
        }

        p:last-of-type {
          margin: 0;
        }
      }

      .st-byline {
        font-family: $font-CuratorRegular;
        font-size: 12px;
        line-height: 14.4px;
        color: #616161;
        text-align: left;
        text-transform: uppercase;
      }

      &::after {
        content: "";
        display: block;
        padding-top: 30px;
      }

      &.plain::after {
        border-bottom: 1px dotted $black;
      }
    }
  }

  &.inverse {
    .main-headline-head-wrapper .main-headline-head .main-headline h1,
    .main-headline-content-wrapper .main-headline-content .st-deck p,
    .main-headline-content-wrapper .main-headline-content .st-byline {
      color: #FFFFFF;
    }
  }
}
</style>
